module.exports = __webpack_public_path__ + "img/tl.1b22495b.svg";